import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TaskTypeService {
  public taskTitleName:string;
  constructor() { }

  public setTaskTitle(name){
    this.taskTitleName = name;
  }

  public getTaskTitle(){
    return this.taskTitleName;
  }
}
